import { InspectionCase } from '../inspection-cases';

export class FireAlarmSystemComponentDto {
  type?: string;
  model?: string;
  manufacture?: string;
  notes?: string;
}

export class FireAlarmSystemComponent extends FireAlarmSystemComponentDto {
  constructor(data: FireAlarmSystemComponentDto = {}) {
    super();
    this.type = data.type;
    this.model = data.model;
    this.manufacture = data.manufacture;
    this.notes = data.notes;
  }
}

export class FireAlarmSystemComponentsDto extends InspectionCase {
  components?: FireAlarmSystemComponentDto[];
}
export class FireAlarmSystemComponents extends FireAlarmSystemComponentsDto {
  constructor(
    data: FireAlarmSystemComponentsDto = { title: 'רשימת הרכיבים במערכת' }
  ) {
    super(data);
    this.components =
      data.components && data.components.length > 0
        ? data.components.map(
            (component) => new FireAlarmSystemComponent(component)
          )
        : [];
  }
}
